import React from 'react';
import PropTypes from 'prop-types';
import stringReplace from 'react-string-replace';

import Tooltip from './tooltip';

class DisclaimerTooltip extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            string: props.string,
            replaced: false
        }
    }

    componentDidMount() {
        this.setString();
    }

    componentDidUpdate(prevProps){
        if(prevProps.string !== this.props.string){
            this.setString();
        }
    }

    setString = () => {
        const { string, footnoteRegex, disclaimers } = this.props;
        if(footnoteRegex.test(string)) {
            const newString = stringReplace(string, footnoteRegex, (match, i) => {
                const matches = match.split(',');
                return (
                    <Tooltip key={i} label={`[${match}]`}>
                    {
                        matches.map((m) => {
                            return (
                                <div key={m}>
                                    {disclaimers.find((disclaimer => disclaimer && disclaimer.includes(`[${m}]`)))}
                                </div>
                            )
                        })
                    }
                    </Tooltip>
                )
            })
            this.setState({string: newString, replaced: true});
        }else{
            this.setState({string: this.props.string, replaced: false});
        }
    }

    render() {
        return this.props.children(this.state.string, this.state.replaced);
    }

}

DisclaimerTooltip.propTypes = {
    string: PropTypes.string.isRequired,
    disclaimers: PropTypes.array.isRequired,
    footnoteRegex: PropTypes.any.isRequired
}

export default DisclaimerTooltip;
